export default function Poses(){
    return <div>
        <h1>poses</h1>
    </div>;
}